import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8iiyhdl1mw: FaireBrandEntity = {
  token: "b_8iiyhdl1mw",
  type: "brand",
  name: "Faithworks by Creative Brands",
  avatarUrl:
    "https://cdn.faire.com/fastly/dcc948b46b72fd17c501265f411c51a80d5d3808362765e71d67a94994841645.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ea8c6ce98c5ed00a0569b1e96ab8192f3769761499296d0981828c88706e043b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/dcc948b46b72fd17c501265f411c51a80d5d3808362765e71d67a94994841645.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ea8c6ce98c5ed00a0569b1e96ab8192f3769761499296d0981828c88706e043b.png",
  location: "Phoenix, AZ, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 302,
  isTopShop: true,
  isInsider: true,
  description:
    "Faithworks has been blessed with over 60 years in the Christian Gift market. Based in Phoenix, AZ, our product development teams and designers are dedicated to offering new products created to inspire and celebrate life's faith-filled moments.\n\nWithin Faithworks, you'll find a family of brands offering uplifting gifts and home décor ranging from traditional to trend-inspired. These exclusive products are sourced throughout the world and fulfilled by distribution and manufacturing facilities located in Lewisburg, TN.\n\nDriven by a dedication to the Christian way of life, our mission at Faithworks is to create a variety of gift products that truly encourage and inspire with an emphasis on quality and value.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:57.760Z",
    importedBy: "entity-db-cli",
  },
};
